module.exports = __webpack_public_path__ + "static/img/ph01.c494eb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/drawn/ph01.jpg
// module id = VJXl
// module chunks = 0